import { client } from '@/client';
import { BeeFreeRequest, BeeFreeResponse } from '@/client/bee-free/types';
import { useMutation } from 'react-query';
import { GenericForbiddenApiError, GetBeeFreeTokenMutation } from './types';

export const useBeeFreeToken = (): {
  create: (payload: BeeFreeRequest) => Promise<BeeFreeResponse>;
} & GetBeeFreeTokenMutation => {
  const { mutateAsync, ...rest } = useMutation<
    BeeFreeResponse,
    GenericForbiddenApiError,
    BeeFreeRequest
  >('addAccountADConfig', (payload: BeeFreeRequest) =>
    client.beeFree.getBeeFreeToken(payload),
  );

  return { create: mutateAsync, ...(rest as any) };
};
